import { ControllerPaletteColor } from './__palette-color';

export enum ControllerDialogColor {
  DefaultFg = ControllerPaletteColor.Gray200,
  BoxShadow = ControllerPaletteColor.BoxShadow1,
}
